import React from 'react';
import { Box, Spinner } from '@cad-arc';
import { LoadingIndicator } from '../../../common/components/loading-indicator';
import { TabSubtitle } from './tab-subtitle';
import { TabNoData } from './tab-no-data';
import { TabIndented } from './tab-indented';
import { observer } from 'mobx-react';

/**
 * Render a tab section with a title and body content
 *
 * If there is no body content, display empty text (defaulting to 'None')
 */
export const TabSection = observer(function TabSection(
    props: React.PropsWithChildren<{
        title?: string;
        titleRightContent?: React.ReactElement;
        emptyText?: string;
        loading?: boolean;
        constrainToParentHeight?: boolean;
        testId?: string;
    }>
): React.ReactElement {
    const testId = props.testId ? { 'data-testid': props.testId } : undefined;
    return props.title || props.children || props.loading ? (
        <Box {...testId} w="100%" h={props.constrainToParentHeight ? '100%' : undefined}>
            {
                // If we want to show a loader, but have no title,
                // then replace all the content with the loader
                props.loading && !props.title ? (
                    <LoadingIndicator />
                ) : (
                    <>
                        {!!props.title && (
                            <TabSubtitle
                                subtitleTrailingNode={!!props.loading && <Spinner size="sm" />}
                                rightContent={props.titleRightContent}
                            >
                                {props.title}
                            </TabSubtitle>
                        )}
                        {
                            // Render the children, if present
                            // Otherwise, render the empty text (if a title was supplied)
                            props.children ||
                                (props.title ? (
                                    <TabIndented>
                                        <TabNoData>{props.emptyText || 'None'}</TabNoData>
                                    </TabIndented>
                                ) : undefined)
                        }
                    </>
                )
            }
        </Box>
    ) : (
        <></>
    );
});
